<template>
    <div>
        <section class="login-form">
            <v-container>
                <v-row v-if="false">
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h1 class="section-title">Registrace</h1>
                        <v-row>
                            <v-col cols="16" offset="0" sm="8" offset-sm="4">
                                <p class="login-form__description">Postav si svůj tým a vyhrajte zážitkový den v
                                    pivovaru nebo poukazy do hospod za více než 1&nbsp;000&nbsp;000 Kč!</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <section class="addpoint">
                        <v-container>
                            <v-row>
                                <v-col cols="14" offset="1" md="10" offset-md="3">
                                    <h2 class="section-subtitle">Prázdninový turnaj byl ukončen a nové zatím nejsou naplánovány. Děkujeme</h2>
                                </v-col>
                            </v-row>
                        </v-container>
                    </section>
                </v-row>
                <v-row v-if="false">
                    <v-col cols="14" offset="1" sm="8" offset-sm="4">
                        <v-card flat>
                            <form @submit.prevent="onSignUp">
                                <v-card-text>
                                    <v-text-field
                                        label="E-mail"
                                        v-model.trim="email"
                                        type="email"
                                        :loading="loadingCheckEmail"
                                        :rules="rules.email"
                                        validate-on-blur
                                    ></v-text-field>
                                    <v-text-field
                                        label="Heslo"
                                        v-model.trim="password"
                                        type="password"
                                        :rules="rules.password"
                                        validate-on-blur
                                    ></v-text-field>
                                    <v-text-field
                                        label="Heslo znova"
                                        v-model.trim="passwordRepeat"
                                        type="password"
                                        :rules="rules.passwordRepeat"
                                        validate-on-blur
                                    ></v-text-field>
                                    <v-text-field
                                        label="Přezdívka"
                                        v-model.trim="nickname"
                                        type="text"
                                        :loading="loadingCheckNickName"
                                        :rules="rules.nickname"
                                        validate-on-blur
                                    ></v-text-field>

                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <div class="agreements">
                                        <v-checkbox
                                            v-model="termsAgreed"
                                            color="primary"
                                        >
                                            <template v-slot:label>
                                                <div class="login-form__agree">Souhlasím s&nbsp;<router-link
                                                    @click.native.prevent="$router.push({ name: 'rules' })"
                                                    :to="{ name: 'rules' }">pravidly soutěže
                                                </router-link>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        <v-checkbox
                                            v-model="gdprAgreed"
                                            color="primary"
                                        >
                                            <template v-slot:label>
                                                <div class="login-form__agree">Souhlasím se zpracováním výše uvedených osobních údajů společně s údaji evidovanými v aplikaci Cool Ticket, více informací &nbsp;<router-link
                                                    @click.native.prevent="$router.push({ name: 'gdpr' })"
                                                    :to="{ name: 'gdpr' }">zde
                                                </router-link>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" class="primary" :disabled="isRegistering || !formIsValid"
                                           :loading="isRegistering">
                                        Registrovat
                                    </v-btn>
                                </v-card-actions>
                            </form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <cta-block></cta-block>
    </div>
</template>

<script>
    import { validator } from '../plugins/validator'
    import { CHECK_EMAIL_REQUEST, CHECK_NICKNAME_REQUEST, REGISTER_REQUEST } from '../store/actions/user'
    import CtaBlock from '../components/Graphics/CtaBlock.vue'

    export default {
        components: {
            CtaBlock,
        },
        data () {
            return {
                termsAgreed: false,
                gdprAgreed: false,
                email: '',
                password: '',
                passwordRepeat: '',
                nickname: '',
                isNickNameUnique: true,
                loadingCheckNickName: false,
                isEmailUnique: true,
                loadingCheckEmail: false,
                isRegistering: false,
            };
        },
        computed: {
            isNickNameAvailable () {
                return this.isNickNameUnique || 'Tato přezdívka je již obsazena, zvolte prosím jinou.';
            },
            isEmailAvailable () {
                return this.isEmailUnique || 'Tento e-mail je již registrován. Přihlašte se prosím.';
            },
            comparePassword () {
                return this.password === this.passwordRepeat || 'Hesla musí být stejná.';
            },
            rules () {
                return {
                    email: [validator.required, validator.email, this.isEmailAvailable],
                    password: [validator.required, validator.password],
                    passwordRepeat: [validator.required, this.comparePassword],
                    nickname: [validator.required, this.isNickNameAvailable],
                };
            },
            formIsValid () {
                return this.email !== ''
                    && validator.email(this.email) === true
                    && this.isEmailAvailable === true
                    && this.password !== ''
                    && this.comparePassword === true
                    && this.nickname !== ''
                    && this.isNickNameAvailable === true
                    && this.termsAgreed !== false
                    && this.gdprAgreed !== false;
            },
        },
        watch: {
            async nickname (nickname) {
                try {
                    this.loadingCheckNickName = true;
                    this.isNickNameUnique = await this.$store.dispatch('user/' + CHECK_NICKNAME_REQUEST, { nickname });
                } finally {
                    this.loadingCheckNickName = false;
                }
            },
            async email (email) {
                if (validator.email(this.email) !== true) {
                    return;
                }

                try {
                    this.loadingCheckEmail = true;
                    this.isEmailUnique = await this.$store.dispatch('user/' + CHECK_EMAIL_REQUEST, { email });
                } finally {
                    this.loadingCheckEmail = false;
                }
            },
        },
        methods: {
            async onSignUp () {
                if (!this.formIsValid) {
                    return;
                }

                const user = {
                    email: this.email,
                    password: this.password,
                    nickname: this.nickname,
                };

                try {
                    this.isRegistering = true;
                    await this.$store.dispatch('user/' + REGISTER_REQUEST, user);
                    this.$toast.success('Registrace byla úspěšně dokončena.');
                    await this.$router.push({ name: 'myTeam' });
                } catch (e) {
                    this.$toast.error('Při registraci došlo k chybě. Zkuste to později.');
                } finally {
                    this.isRegistering = false;
                }
            },
        },
    }
</script>
